/**
 * Manually derived from: https://shopify.dev/docs/api/admin-graphql/2023-04/objects/CompanyContactRoleAssignment
 * API Version: 2022-10
 */

import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyCompanyContactKey,
  ShopifyCompanyContactRoleAssignmentKey,
  ShopifyCompanyContactRoleAssignmentToCompanyContactKey,
  ShopifyCompanyContactRoleAssignmentToCompanyContactRoleKey,
  ShopifyCompanyContactRoleAssignmentToCompanyKey,
  ShopifyCompanyContactRoleAssignmentToCompanyLocationKey,
  ShopifyCompanyContactRoleAssignmentToShopKey,
  ShopifyCompanyContactRoleKey,
  ShopifyCompanyKey,
  ShopifyCompanyLocationKey,
  ShopifyShopKey,
} from "./keys";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyCompanyContactRoleAssignmentKey,
  "2022-10": {
    name: "Shopify Company Contact Role Assignment",
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "id" } },
      },
      {
        name: "Company",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCompanyContactRoleAssignmentToCompanyKey,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "company", graphQLSelection: "id" } },
        configuration: {
          relatedModelKey: ShopifyCompanyKey,
        },
      },
      {
        name: "Company Contact",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCompanyContactRoleAssignmentToCompanyContactKey,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "companyContact", graphQLSelection: "id" } },
        configuration: {
          relatedModelKey: ShopifyCompanyContactKey,
        },
      },
      {
        name: "Company Location",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCompanyContactRoleAssignmentToCompanyLocationKey,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "companyLocation", graphQLSelection: "id" } },
        configuration: {
          relatedModelKey: ShopifyCompanyLocationKey,
        },
      },
      {
        name: "Role",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCompanyContactRoleAssignmentToCompanyContactRoleKey,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "role", graphQLSelection: "id" } },
        configuration: {
          relatedModelKey: ShopifyCompanyContactRoleKey,
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyCompanyContactRoleAssignmentToShopKey,
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: {
      type: "graphql_sublist", // sublist of a sublist?
      resource: "companyLocation.roleAssignments",
      parent: "companyLocations",
    },
  },
};

export const ShopifyCompanyContactRoleAssignment = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
